import { FC } from 'react';

export const NoData: FC = ({ children }) => <div className="text-xs font-medium text-gray-400 italic text-center py-8">{children}</div>;
